import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IoAddCircleOutline } from "react-icons/io5";
import { ClimbingBoxLoader } from "react-spinners";

import TitleBar from "../components/TitleBar/TitleBar";
import {
    HunterInteractionType,
    HunterOutfit,
    HunterOutfitFilter,
} from "@mythic/coms/types";
import OutfitCard from "../components/HunterFashion/OutfitCard";
import { useParams } from "react-router-dom";
import HunterFilter from "../components/HunterFashion/HunterFilter";

import styles from "./HunterFashionCollection.module.css";

export default function HunterFashionCollection() {
    const navigate = useNavigate();
    const { userId } = useParams();

    const [isLoading, setIsLoading] = useState(true);
    const [collection, setCollection] = useState<
        (HunterOutfit & {
            _id?: string;
            isFavorited?: boolean;
            isLiked?: boolean;
            likeCount?: number;
            favCount?: number;
        })[]
    >([]);

    const [filters, setFilters] = useState<HunterOutfitFilter>({});
    const [perPage, setPerPage] = useState(25);

    useEffect(() => {
        fetchData(
            userId
                ? {
                      creatorId: userId,
                  }
                : {},
        );
    }, [userId]);

    const fetchData = (filter: Partial<HunterOutfitFilter>) => {
        setIsLoading(true);
        const opts = {
            limit: perPage,
            filter,
        };

        fetch(`${import.meta.env.VITE_SERVER_URL}/api/hunterfashion/get`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json", // This is the missing piece!
            },
            body: JSON.stringify(opts),
            credentials: "include",
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.ok) setCollection(data.outfits);
                console.log(data);
            })
            .finally(() => setIsLoading(false));
    };

    const handleInteract = (
        interaction: HunterInteractionType,
        outfitId: string,
    ) => {
        setCollection((prev) => {
            const newCollection = prev.map((outfit) => {
                if (outfit._id === outfitId)
                    return {
                        ...outfit,
                        ...(interaction === "like"
                            ? {
                                  isLiked: true,
                                  likeCount: (outfit.likeCount ?? 0) + 1,
                              }
                            : {}),
                        ...(interaction === "unlike"
                            ? {
                                  isLiked: false,
                                  likeCount: (outfit.likeCount ?? 1) - 1,
                              }
                            : {}),
                        ...(interaction === "favorite"
                            ? {
                                  isFavorited: true,
                                  favCount: (outfit.favCount ?? 0) + 1,
                              }
                            : {}),
                        ...(interaction === "unfavorite"
                            ? {
                                  isFavorited: false,
                                  favCount: (outfit.favCount ?? 1) - 1,
                              }
                            : {}),
                    };
                else return outfit;
            });

            return newCollection;
        });
    };

    return (
        <>
            <TitleBar title="My Fashion" />
            <div className={styles.fashionBody}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <button
                        style={{ margin: "0 1rem" }}
                        onClick={() => navigate("/hunterfashion/editor")}
                    >
                        Create{" "}
                        <IoAddCircleOutline
                            style={{
                                fontSize: "1.2rem",
                                lineHeight: "1rem",
                            }}
                        />
                    </button>
                    <HunterFilter
                        filters={filters}
                        perPage={perPage}
                        onChange={(key, value) => {
                            if (key === "perPage") {
                                setPerPage(value);
                            } else
                                setFilters((prev) => {
                                    if (value) return { ...prev, [key]: value };
                                    const newFilters = { ...prev };
                                    delete newFilters[key];
                                    return newFilters;
                                });
                        }}
                        onReset={() => {
                            setFilters({});
                            fetchData({});
                        }}
                        onSubmit={() => {
                            fetchData(filters);
                        }}
                    />
                </div>
                {!isLoading && (
                    <div className={styles.fashionCollection}>
                        {collection.map((outfit) => {
                            return (
                                <OutfitCard
                                    key={outfit._id}
                                    outfit={outfit}
                                    onInteract={(i) =>
                                        handleInteract(i, outfit._id ?? "")
                                    }
                                    small
                                />
                            );
                        })}
                    </div>
                )}
            </div>
            <div className={styles.pageSelector}></div>
            <ClimbingBoxLoader
                style={{
                    position: "fixed",
                    top: 0,
                    bottom: 0,
                    display: "block",
                    width: "100%",
                    backgroundColor: "rgba(0,0,0,0.5)",
                }}
                size={30}
                color="#b64ce7"
                loading={isLoading}
            />
        </>
    );
}
